<template>
    <div class="pt-2 pl-2">
        <v-row no-gutters>
            <v-col cols="6" class="pr-1">
                <v-card class="default_card_wm elevation-0 pt-2">
                    <DocumentMenu 
                        :MenuOptions="documentMenuOptions"
                        @back="back()"
                        @display-file="showAccountingLines = false; displayActivity = false;"
                        @display-accounting-line="showAccountingLines = true; displayActivity = false;"
                        @download="startDownloadFile()"
                        @activity="displayActivity = true"
                        @delete="deleteDocumentDialog = true"
                    />
                    <v-row no-gutters>
                        <!--<v-col cols="6" class="d-flex align-center">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="mode !== 'GeneralLedger' && goBackHistory"
                                data-cy="document-back"
                            />
                            <h2 v-if="document.signedUrl">Contenu du virement Sepa</h2>
                            <!-- <template v-if="zoomManager && !showAccountingLines">
                                    <v-btn
                                        :disabled="zoomManager.disableZoomOut()"
                                        class="btn mr-1"
                                        icon size="small"
                                        color="primary"

                                        @click.stop="zoomManager.zoomOut()"
                                        v-if="showZoomActions"
                                    >
                                        <v-icon>$oss-zoom-out</v-icon>
                                    </v-btn>
                                    <v-btn
                                        :disabled="zoomManager.disableResetZoom()"
                                        class="btn mx-1"
                                        icon size="small"
                                        color="primary"

                                        @click.stop="zoomManager.resetZoom()"
                                        v-if="showZoomActions"
                                    >
                                        <v-icon>$oss-focus</v-icon>
                                    </v-btn>
                                    <v-btn
                                        :disabled="zoomManager.disableZoomIn()"
                                        class="btn ml-1"
                                        icon size="small"
                                        color="primary"

                                        @click.stop="zoomManager.zoomIn()"
                                        v-if="showZoomActions"
                                    >
                                        <v-icon>$oss-zoom-in</v-icon>
                                    </v-btn>
                                </template> -->
                                <!--
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end">
                            <v-btn-icon
                                v-if="document.signedUrl && isAccountingUser"
                                v-model="showAccountingLines"
                                rounded="xl"
                                class="mt-1"
                                density="compact"
                                outlined
                                mandatory
                                color="secondary"
                            >
                                <v-btn-icon
                                    icon="$oss-file"
                                    :value="0"
                                    @click="
                                        showAccountingLines = false;
                                        displayActivity = false;
                                    "
                                />
                                <v-btn-icon
                                    icon="$oss-accounting-lines"
                                    :value="1"
                                    @click="
                                        showAccountingLines = true;
                                        displayActivity = false;
                                    "
                                />
                            </v-btn-icon>
                            <v-btn-icon
                                icon="$oss-file"
                                v-else-if="document.signedUrl && displayActivity"
                                color="seconday"
                                class="mx-1"
                                @click="displayActivity = false"
                            ></v-btn-icon>
                            <v-btn-icon
                                icon="$oss-download"
                                color="seconday"
                                class="mx-1"
                                :disabled="!document.signedUrl"
                                @click="startDownloadFile"
                            />
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$dots_vertical"
                                        v-bind="props"
                                        class="mx-1"
                                        color="seconday"
                                    />
                                </template>
                                <v-list>
                                    <v-list-item
                                        @click="displayActivity = true"
                                        v-if="isAccountingUser"
                                    >
                                        <v-list-item-title>Afficher l'activité</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mb-2" />
                                    <v-list-item
                                        @click="deleteDocumentDialog = true"
                                        :disabled="disabledDelete"
                                        color="error"
                                        :active="!disabledDelete"
                                    >
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>-->
                        <v-col cols="12" v-if="isPDF" class="d-flex justify-center">
                            <ossPdf :documentId="document.id" />
                        </v-col>
                        <template
                            v-if="showAccountingLines && !displayActivity && isAccountingUser"
                        >
                            <!--- AccountingItemStaticFull -->
                            <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                                <accounting-item-static
                                    :companyId="companyId"
                                    :documentId="document.id"
                                    :mode="isAccountingItem ? 'AllOption' : 'Embedded'"
                                    ref="accountingItemStatic"
                                    :key="accountingLinesRefreshKey"
                                    @upsert="onAccountingItemUpdated"
                                />
                            </v-col>
                        </template>
                        <template v-else-if="displayActivity">
                            <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                                <UsersActivitiesHistory :documentId="document.id">
                                </UsersActivitiesHistory>
                            </v-col>
                        </template>
                        <template v-else-if="document.signedUrl">
                            <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                                <div v-html="xml" v-if="xml" />
                                <div v-else>{{ xmlAsString }}</div>
                            </v-col>
                            <!-- <div>{{xml}}</div> -->

                            <!-- <v-col cols="12" style="max-height: 85vh; overflow-y: auto">
                                    <div style="position: relative;width: 100%; height: 0; padding: 0;padding-bottom: 141.4516129032258%; margin-bottom: 50px;">
                                        <svg
                                            id="svg-document-miscellaneous"
                                            v-if="document"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="100%"
                                            :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                            style="position: absolute; width: 100%; left: 0; top: 0; background: #FFF"
                                        >
                                            <image
                                                id = "svg-image-document-miscellaneous"
                                                :xlink:href="document.signedUrl"
                                                x="0"
                                                y="0"
                                                :height="`${imageHeight}px`"
                                                :width="`${imageWidth}px`"
                                            />
                                        </svg>
                                    </div>
                                </v-col> -->
                        </template>
                    </v-row>
                </v-card>
                <v-list v-if="associatedFields.show" :style="svgPosition">
                    <v-list-item
                        v-for="(field, key, index) in associatedFields.fields"
                        :key="`field-${document.id}-${key}-${index}`"
                        @click="onFieldAssociation(field, key)"
                        class="oss-list-item"
                    >
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col cols="6" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                        height: calc(100vh - 82px);
                        overflow-y: auto;
                    "
                    class="default_card_wm elevation-0 rounded-l-0"
                >
                    <v-card-text class="pt-0">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-list single-line class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Statut</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div
                                                        v-if="
                                                            document.errorMessage &&
                                                            reUploadDocument
                                                        "
                                                        style="color: red"
                                                    >
                                                        Erreur : {{ document.errorMessage }}
                                                    </div>
                                                    <div
                                                        v-else-if="document.errorMessage"
                                                        style="color: red"
                                                    >
                                                        Erreur de lecture du fichier : contacter
                                                        votre cabinet
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            document.status === 'ORIGINAL_UPLOADED'
                                                        "
                                                    >
                                                        En attente d'analyse
                                                    </div>
                                                    <div v-else-if="document.status === 'UPLOADED'">
                                                        En attente d'analyse
                                                    </div>
                                                    <div v-else>OK</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item :ripple="false" class="oss-list-item my-2">
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters class="align-center">
                                                <v-col
                                                    cols="3"
                                                    style="
                                                        border-right: 1px #ededed solid;
                                                        height: 28px;
                                                    "
                                                    class="d-flex align-center"
                                                >
                                                    <b>Type</b>
                                                </v-col>
                                                <v-col cols="9" class="pl-2">
                                                    {{ formatCategory(document.type) }}
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item
                                        :ripple="false"
                                        class="mb-2"
                                        color="success"
                                        v-if="showRestoreDocumentBtn"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters class="align-center">
                                                <v-col
                                                    cols="3"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Actions</b>
                                                </v-col>
                                                <v-col
                                                    cols="9"
                                                    class="d-flex justify-end align-center"
                                                >
                                                    <v-tooltip
                                                        v-if="canBeRestoredTooltipMessages?.length"
                                                        class="pt-4 px-4"
                                                        location="bottom"
                                                    >
                                                        <template v-slot:activator="{ props }">
                                                            <div style="height: fit-content" v-bind="props">
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    disabled
                                                                    size="small"
                                                                >
                                                                    Restaurer
                                                                    <v-icon size="small" location="end">
                                                                        $oss-edit
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>

                                                        <template v-for="line of canBeRestoredTooltipMessages">
                                                            <h4>
                                                                {{ line }}
                                                            </h4>
                                                        </template>
                                                    </v-tooltip>

                                                    <template v-else>
                                                        <v-btn
                                                            rounded
                                                            elevation="0"
                                                            @click="restoreDialog = true"
                                                            size="small"
                                                        >
                                                            Restaurer
                                                            <v-icon size="small" location="end">
                                                                $oss-edit
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <!-- <v-col cols="12" class="d-flex justify-center align-center py-1">
                                    <v-text-field
                                        v-model="document.displayName"
                                        label="Nom du document"
                                        outlined
                                        dense
                                        hide-details
                                    ></v-text-field>
                                </v-col> -->
                            <v-col v-if="activateTagguing">
                                <FreeTag
                                    :companyTags="allCompanyTags"
                                    :document="inDocument"
                                    :splitUserPartitions="true"
                                    @changed="startToBeDoneIfNecessary"
                                />
                            </v-col>
                            <v-col cols="12" class="d-flex justify-end align-center py-3">
                                <Sepa
                                    :mode="'Embedded'"
                                    :companyId="companyId"
                                    :document="inDocument"
                                    @onUpdated="onUpdated"
                                >
                                </Sepa>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex justify-center align center">
                                <v-btn-prev :disabled="previousDisabled()" @click="previous()" />
                                <v-btn-next :disabled="nextDisabled()" @click="next()" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <DocumentWizardDialog
            v-model:active="activeUploadDocument"
            v-bind:companyId="companyId"
            v-bind:documentId="document.id"
            v-bind:documentType="document.type"
            v-bind:showFirstPrevious="false"
            v-bind:multiple="false"
            @fileUploaded="onFileUploaded"
        />
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
        <Chat
            v-if="openChat"
            v-bind:id="document.chat ? document.chat.id : ''"
            v-bind:status="'INFORMATION_REQUEST'"
            :showSmartChat="false"
        />
        <oss-dialog
            v-model="restoreDialog"
            title="Restaurer le document"
            @valid="
                restoreDocument();
                restoreDialog = false;
            "
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="restoreLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir restaurer le document ?</h4>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { User } from "../../../../types";

import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";
import UPDATE_DOCUMENT_TYPE from "../../graphql/document/UpdateDocumentType.gql";
import UPDATE_DOCUMENT_NAME from "../../graphql/document/UpdateDocumentName.gql";

import { DocumentBase } from "./DocumentBase";
import ossPdf from "./DocumentPDF.vue";
import { DocumentMenu } from "./DocumentMenu.vue"
import DocumentWizardDialog from "./DocumentWizardDialog.vue";
import Chat from "../chat/Chat.vue";
import FreeTag from "../tag/FreeTag.vue";
import Sepa from "../pay/Sepa.vue";
import AccountingItemStatic from "../AccountingItemStatic.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import { Component, toNative } from "vue-facing-decorator";
import { Watch, Emit } from "vue-facing-decorator";

import { MenuDisplayDisplayModeOptions, MenuDisplayDotMenuOptions, MenuDisplayDownloadOptions, MenuDisplayOptions, MenuDisplayTitleOptions } from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

@Component({
    components: {
        DocumentWizardDialog,
        Chat,
        ossPdf,
        FreeTag,
        Sepa,
        AccountingItemStatic,
        UsersActivitiesHistory,
        DocumentMenu
    },
})
export class DocumentSepa extends DocumentBase {
    items: Array<any> = [];

    valid = false;

    loading = false;

    updating = false;

    dialogSelectCompany = false;

    activeUploadDocument = false;

    showAccountingLines: boolean = false;

    restoreDialog = false;

    get documentMenuTitleOptions(): MenuDisplayTitleOptions {
        const titleOptions: MenuDisplayTitleOptions = { ...documentMenuDisplayOptionsDefaultScheme.title }

        titleOptions.isDisplay = true;
        titleOptions.text = "Contenu du virement Sepa";

        return titleOptions;
    }

    get documentMenuDownloadOptions(): MenuDisplayDownloadOptions {
        const downloadOptions: MenuDisplayDownloadOptions = { ...documentMenuDisplayOptionsDefaultScheme.downloadButton };

        downloadOptions.isDisplay = true;
        downloadOptions.disabled = !this.document.signedUrl;

        return downloadOptions;
    }

    get documentMenuDisplayModeOptions(): MenuDisplayDisplayModeOptions {
        const displayModeOptions: MenuDisplayDisplayModeOptions = { ...documentMenuDisplayOptionsDefaultScheme.displayModeButtons };

        displayModeOptions.isDisplay = true;
        displayModeOptions.isAccountingLineModeDisplay = this.document.signedUrl && this.isAccountingUser && this.document.accountingLines?.length;
        displayModeOptions.isPDFModeDisplay = (this.document.signedUrl && this.isAccountingUser) || (this.document.signedUrl && this.displayActivity);

        return displayModeOptions;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenu: MenuDisplayDotMenuOptions = { ...documentMenuDisplayOptionsDefaultScheme.dotMenu };

        dotMenu.isDisplay = true;
        
        dotMenu.activity.isDisplay = this.isAccountingUser;
        dotMenu.activity.title = "Afficher l'activité";

        dotMenu.delete.isDisplay = true;
        dotMenu.delete.title = "Supprimer";
        dotMenu.delete.disabled = this.disabledDelete;

        return dotMenu 
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = { ...documentMenuDisplayOptionsDefaultScheme };

        documentMenuOption.title = this.documentMenuTitleOptions;
        documentMenuOption.downloadButton = this.documentMenuDownloadOptions;
        documentMenuOption.displayModeButtons = this.documentMenuDisplayModeOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    get reUploadDocument() {
        if (!this.document) return false;
        if (this.currentUser.profile.configuration.document.write) {
            return true;
        }
        return false;
    }

    documentType_ = "";

    get documentType() {
        if (this.documentType_) {
            return this.documentType_;
        }
        return this.document.type;
    }

    set documentType(data) {
        this.documentType_ = data;
    }

    get disabledChangeType() {
        if (this.documentType === "MISCELLANEOUS") {
            return true;
        }
        if (
            (this.documentType === "CURRENT_ACCOUNT" ||
                (this.documentType === "OPERATOR_ACCOUNT" && !this.isAutonomousUser)) &&
            !(this.currentAccountUser && this.currentAccountUser.id)
        ) {
            return true;
        }
        return false;
    }

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.users) {
                    this.currentAccountUsers = data.users;
                    this.updateCurrentAccountUser();
                }
            }
        },
    })
    currentAccountUsers: User[] = [];

    updateCurrentAccountUser() {
        const currentAccountUsers = this.getUsers();
        if (currentAccountUsers.length) {
            if (this.inDocument.owner) {
                const foundUser = currentAccountUsers.find(
                    (u) => u.id === this.inDocument.owner.id,
                );
                if (foundUser) {
                    this.currentAccountUser = foundUser;
                } else {
                    this.currentAccountUser = currentAccountUsers[0];
                }
            } else {
                this.currentAccountUser = currentAccountUsers[0];
            }
        } else {
            this.currentAccountUser = this.defaultUser;
        }
    }

    onFileUploaded() {
        // this.uploadFileLoading = false;
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        await this.onDocumentChangedCommon(prev, next);
        if (prev !== next) {
            if (!this.document?.signedUrl && this.isAccountingUser) {
                this.showAccountingLines = true;
            }
            if (!this.document.displayName) {
                this.document.displayName = this.document.name;
            }
            this.finishMounted();
        }
    }

    beforeMount() {
        this.svgSuffix = "document-miscellaneous";
        //
        this.onDocumentChanged(this.inDocument.id, undefined);
    }

    switchToDocumentValidationDialog: boolean = false;

    async switchToDocumentValidation() {
        await this.updateDocument("ANALYSED");
        this.onEdit();
        this.switchToDocumentValidationDialog = false;
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "type";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }

    async updateDocument(status) {
        await this.$apollo.mutate({
            mutation: UPDATE_DOCUMENT_NAME,
            variables: {
                id: this.document.id,
                name: this.document.displayName,
            },
        });
        if (!this.disabledChangeType) {
            await this.$apollo.mutate({
                mutation: UPDATE_DOCUMENT_TYPE,
                variables: {
                    id: this.document.id,
                    type: this.documentType,
                    owner: this.currentAccountUser.id
                        ? { connect: { id: this.currentAccountUser.id } }
                        : undefined,
                    status,
                },
            });
            if (
                this.documentType !== "MISCELLANEOUS" &&
                this.documentType !== "SEPA" &&
                this.documentType !== "SUBSCRIPTION" &&
                this.documentType !== "SUBSCRIPTION_ACCOUNTING" &&
                this.documentType !== "LOAN" &&
                this.documentType !== "LOAN_ACCOUNTING" &&
                this.documentType !== "LEASING" &&
                this.documentType !== "LEASING_ACCOUNTING"
            ) {
                await this.analyseDocument();
            }

            this.onEdit();
        }
    }

    @Emit("edit")
    onEdit() {
        return {
            documentId: this.documentId,
        };
    }
    async validateSepa() {
        // debugger
        await this.updateDocument("ORIGINAL_UPLOADED");
        this.onEdit();
    }

    //
    // CHAT
    //
    open_chat: boolean = false;

    get openChat() {
        if (this.document.chat) {
            return true;
        }
        return this.open_chat;
    }

    // space(indent) {
    //     // return ""
    //     let space = ""
    //     let i = 0
    //     while (i < indent) {
    //         space += " "
    //         i++
    //     }
    //     return space
    // }

    recXml(node, result) {
        if (node.nodeName && node.nodeName !== "#text") {
            result.html += `<div style="padding-left:${result.indent}px;">&lt;${node.nodeName}&gt;`;
        }
        if (node.nodeValue) {
            result.html += node.nodeValue;
        } else {
            if (node.childNodes) {
                result.indent += 5;
                for (let i = 0; i < node.childNodes.length; i++) {
                    this.recXml(node.childNodes[i], result);
                }
                result.indent -= 5;
            }
            // if (node.nodeName) {
            //     result.html += this.space(result.indent) + node.nodeName + "/n"
            // }
        }
        if (node.nodeName && node.nodeName !== "#text") {
            result.html += "&lt;/" + node.nodeName + "&gt;" + "</div>";
        }
    }

    get xmlAsString() {
        if (this.document.signedUrl) {
            const request = new XMLHttpRequest();
            request.open("GET", this.document.signedUrl, false);
            request.send();
            const xmlDoc = request.responseXML;
            if (!xmlDoc) {
                return request.responseText;
            }
        }
        return "";
    }

    get xml() {
        if (this.document.signedUrl) {
            const request = new XMLHttpRequest();
            request.open("GET", this.document.signedUrl, false);
            request.send();
            const xmlDoc = request.responseXML;
            if (!xmlDoc) {
                if (!xmlDoc?.children?.length) {
                    return "";
                }
                // return xmlDoc.innerHTML

                // let txt = ""
                // for (const child of xmlDoc.children) {
                //     // this.recXml(xmlDoc.children[i], result)
                //     txt += child.innerHTML + "<br/>";
                // }
                // return txt

                const result = {
                    html: "",
                    indent: 0,
                };
                // const grpHdr = xmlDoc.getElementsByTagName("GrpHdr");
                for (let i = 0; i < xmlDoc.children.length; i++) {
                    this.recXml(xmlDoc.children[i], result);
                    // txt += x[i].childNodes[0].nodeValue + "<br/>";
                }

                // const pmtInf = xmlDoc.getElementsByTagName("PmtInf");
                // for (let i = 0; i < grpHdr.length; i++) {
                //     this.recXml(pmtInf[i], result)
                //     // txt += x[i].childNodes[0].nodeValue + "<br/>";
                // }
                // document.getElementById("demo").innerHTML = txt;

                return result.html;
                // var users = xml.getElementsByTagName("user");
                // for(var i = 0; i < users.length; i++) {
                //     var user = users[i];
                //     var names = user.getElementsByTagName("name");
                //     for(var j = 0; j < names.length; j++) {
                //         alert(names[j].childNodes[0].nodeValue);
                //     }
                // }
            }
            // return request.responseText || ""
        }
        return "";
    }
}

export default toNative(DocumentSepa);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
